export default __webpack_public_path__ + "static/media/ikoni_tarkastelu.80c23066.svg";